
export const AuthAbsentisme = ({ auth, handleChange, error }) => {
  return (<>
    <div className="row">
    <div className="col col-12 ">
      <h4>
      Autorització de cessió de dades per a l'orientació en situacions d'absentisme i abandonament d'estudis
      </h4>
      <p>
      (Els majors de 14 anys no necessiten l'autorització del pare, mare o representant legal.)<br/>

        Per millorar l'orientació educativa de l'alumnat, el Departament d'Educació sol-licita l'autorització per
        comunicar determinades dades personals dels alumnes a l'Administració local i a l'Administració
        educativa, que ofereixen un servei d'orientació per donar noves oportunitats als estudiants que es
        troben en situació d'absentisme o decideixen abandonar els estudis iniciats, per motius diversos.
        Les dades que es poden comunicar són les identificatives i de contacte, nacionalitat, sexe, mes i any de
        naixement, i de matrícula i nivell d'ensenyament dels alumnes.
      </p>

        <input type="checkbox" id="authAbsentisme" name="authAbsentisme" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange(t.target.value) } } required/>
        <label htmlFor="authAbsentisme"> AUTORITZO  el Departament d'Educació a comunicar les dades personals indicades a l'Administració local i l'Administració educativa, exclusivament per gestionar els processos d'acompanyament, orientació, suport i assessorament en les situacions d'absentisme o abandonament d'estudis.  </label>
        <span id="auhtAbsentisme_ERROR" className="a-Form-error">{error}</span>

      <br />
      <p>
          <i>Aquesta autorització té validesa durant els pròxims 10 anys o fins que l'alumne/a compleixi 24 anys.  Podeu retirar el vostre consentiment en qualsevol moment.</i>
      </p>

    </div>
  </div>

    <br />
  </>)
}
